import dayjs from 'dayjs';
import { LOGIN_SUCCESS, LOGOUT } from './redux/actions/types';
import i18n from './i18n';
import namedBaselines from './misc/namedBaselines';

// const debugLevel = process.env.REACT_APP_MDEBUG || 3;
const debugLevel = 0;

// take whatever currentAuthenticatedUser returns and update the store with it
/**
 * @deprecated functionality now in initAuth.js
 */
export function updateStoreWithAttributes(user, store) {
  if (debugLevel > 2) console.info('Hub Listener: updateStoreWithAttributes(user)', user);
  // prepare data
  const defaultBaselineDate = {
    name: 'sameTimeLastYear',
    date: namedBaselines.sameTimeLastYear,
  };
  const settingsString = user.attributes['custom:settings'];
  const settings = settingsString
    ? JSON.parse(settingsString)
    : {
      baseCurrency: 'EUR',
      baselineDate: defaultBaselineDate.date,
      namedBaseline: defaultBaselineDate.name,
      inflationRate: 3.0,
      sliderStartDate: dayjs().subtract(10, 'year').startOf('year').valueOf(),
      sliderEndDate: dayjs().add(20, 'year').startOf('year').valueOf(),
      expectedDateFormats: ['DD.MM.YYYY', 'YYYY-MM-DD', 'DD.MM.YY', 'DD/MM/YYYY', 'DD-MM-YYYY'], // default setting
    };

  const locale = user.attributes.locale || null;
  if (locale !== i18n.language && locale?.length === 2) {
    i18n.changeLanguage(locale);
  }

  // needed for persist.js
  const { sub } = user.attributes;

  store.dispatch({
    type: LOGIN_SUCCESS,
    // just send settings and toursseen, the rest is not needed
    // INFO: toursSeen are used in the Prep component to determine whether to create demo data or not (if there are no toursSeen, then it will create demo data)
    payload: {
      toursSeen: JSON.parse(user.attributes['custom:tours_seen'] || 'null'),
      settings,
      locale,
      sub,
    },
  });
}

const eventAliasMap = {
  signedIn: 'signIn',
  signedOut: 'signOut',
  tokenRefreshFailure: 'tokenRefresh_failure',
  tokenRefreshFailed: 'tokenRefresh_failure',
  userDeleted: 'signOut',
};

export default function listener(capsule, store) {
  const payload = capsule?.payload ?? {};
  const originalEvent = payload?.event;
  const event = originalEvent ? eventAliasMap[originalEvent] ?? originalEvent : originalEvent;
  const { data } = payload;

  // Listening for all messages
  if (debugLevel > 2) {
    console.info('Amplify hub event', {
      originalEvent,
      normalizedEvent: event,
      data,
      source: capsule?.source,
    });
  }

  if (!event && !data?.url) {
    return;
  }

  // INFO: (apparently) Amplify "recognises" a callback by specific query parameters in the URL (e.g. setup_intent, id_token, code, state).
  // INFO: Amplify emits a parsingCallbackUrl on its 'auth' channel when the website is loaded, and passes the URL as payload.data.url
  // INFO: the functions here are executed before CallbackHandler had a chance to run

  // handle application start ---------------------------------------------------------------------------------------------------

  // 251106 now handled by initAuth

  // handle token refresh failure -----------------------------------------------------------------------------------------------

  if (event === 'tokenRefresh_failure') {
    store.dispatch({
      type: 'SET_APP_SIGNAL',
      payload: { callerId: 'RequireAuth', message: 'tokenRefresh_failure' },
    });
  }

  // handle signIN --------------------------------------------------------------------------------------------------------------

  // 251107 handled in initAuth

  // handle FEDERATED signUP ---------------------------------------------------------------------------------------------------

  // 251107 moved to CallbackHandler.jsx

  // handle signOUT -------------------------------------------------------------------------------------------------------------
  if (event === 'signOut') {
    // does it have to happen in PerformLogout AND here?
    store.dispatch({
      type: LOGOUT,
    });
  }
}
